import { AnimatePresence } from 'framer-motion'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { FormBackground, FormBody, FormContentContainer } from '../Form/FormStyles'
import FormNavbar from '../Form/components/FormNavbar'
import { SOMYA_ADDICTION_EVENT_URL } from '../PersonalizedPlan/BehavioralAddictionPlan'
import AddictionTypesSelectionPageStateController from './components/AddictionTypesSelectionPageStateController'
import { ADDICTION_TYPES_PAGES, redirectToRelevantAssessment } from './utils'

export default function AddictionTypesSelection({ type }) {
  const backButtonVisible = true
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    addictionTypes: [],
    frequency: null,
    frequencyRate: 'day',
    goal: null,
    goalRate: 'day',
  })
  const [pageStack, setPageStack] = useState([ADDICTION_TYPES_PAGES.addictionTypeSelection])

  function handleBack() {
    if (pageStack?.length > 1) {
      setPageStack((prev) => prev?.slice(0, prev?.length - 1))
      return
    }
    navigate(-1)
  }

  function pushPage(page) {
    setPageStack((prev) => [...prev, page])
  }

  function finallyGoTo(addictionType) {
    if (type === 'assessment-selection') {
      redirectToRelevantAssessment({ addictionType, navigate })
      return
    }

    navigate(`${SOMYA_ADDICTION_EVENT_URL}?src=behavioral-addiction-plan`, {
      state: {
        addictionFormData: {
          refType: 'personalized-plan',
          refId: 'de-addiction',
          subIds: formData?.addictionTypes,
          customMap: {
            frequency: formData?.frequency,
            frequencyType: formData?.frequencyRate,
            goal: formData?.goal,
            goalType: formData?.goalRate,
          },
        },
      },
    })
  }

  return (
    <FormBackground>
      <FormNavbar
        goBackFunction={handleBack}
        backVisible={backButtonVisible}
        languageSelectVisible={false}
        logoutDropDownVisible={true}
      />
      <AnimatePresence initial={false}>
        <FormBody
          initial={{ opacity: 0, x: 0 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: 0 }}
          // initial={{ opacity: 0, x: '50%' }}
          // animate={{ opacity: 1, x: 0 }}
          // exit={{ opacity: 0, x: '-50%' }}
          transition={{ duration: 0.5, delay: 0.3 }}
          hasContinueButton={true}
        >
          <FormContentContainer>
            <AddictionTypesSelectionPageStateController
              formData={formData}
              setFormData={setFormData}
              finallyGoTo={finallyGoTo}
              pushPage={pushPage}
              currentPage={pageStack?.[pageStack?.length - 1]}
              webPageType={type}
            />
          </FormContentContainer>
        </FormBody>
      </AnimatePresence>
    </FormBackground>
  )
}
